"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketSideNames = marketSideNames;
/**
 * A picker row's [YES, NO] side names, for a leg's side toggle. PM-US keeps
 * them in `sideNames` so its rows still show and filter on the market type.
 */
function marketSideNames(market) {
    return market.sideNames ?? [market.yes_sub_title ?? "", market.no_sub_title ?? ""];
}
